import { render } from "./Custom01.vue?vue&type=template&id=7cfab7bd&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./Custom01.vue?vue&type=script&lang=ts"
export * from "./Custom01.vue?vue&type=script&lang=ts"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__